import i18n from '~/i18n/locale';

/*
  This Vue plugin allows us to use i18n-js in all our Components.

  It has a mixin with two methods:

  t(..args)

  This method translates just like the t function in 118n-js

  currentLocale()

  This method returns the current locale
*/
const I18nVuePlugin = {
  install(app) {
    app.config.globalProperties.t = (...args) => i18n.t(...args);
    app.config.globalProperties.currentLocale = () => i18n.locale;
  }
};

export default I18nVuePlugin;
